module.exports = __webpack_public_path__ + "img/gpu.9925003f.svg";